// @ts-nocheck
import React, { Component } from 'react';
import { observer, inject } from "../../stores/mobx-compat";

import CaptureLogo from '../ui/CaptureLogo';
import Button from '../ui/Button';
import { MailIcon } from '../ui/icons';

class EmailVerificationPage extends Component {
  state = { linkSent: false };

  sendVerificationLink = () => {
    const { email } = this.props.store.firebase.auth().currentUser;
    this.props.store.auth.sendCustomVerificationEmail(email);
    this.setState({ linkSent: true });
  }

  componentDidMount() {
    const { email } = this.props.store.firebase.auth().currentUser;
    this.props.store.auth.sendCustomVerificationEmail(email);
  }

  render() {
    return (
      <div className="mov-app auth-root" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
        <div style={{ width: '100%', maxWidth: 460 }}>
          <div className="flex justify-center mb-6">
            <CaptureLogo style={{ width: 160 }} />
          </div>
          <div
            className="text-center"
            style={{
              background: 'var(--mov-paper)',
              border: '1px solid var(--mov-line)',
              borderRadius: 14,
              padding: 28,
              boxShadow: 'var(--mov-shadow-card)',
            }}
          >
            <div
              className="grid place-items-center mx-auto mb-4"
              style={{
                width: 56, height: 56, borderRadius: '50%',
                background: 'var(--mov-accent-soft)', color: 'var(--mov-accent-ink)',
              }}
            >
              <MailIcon size={22} />
            </div>
            <h1 className="mov-display m-0 mb-2" style={{ fontSize: 26, lineHeight: 1.1 }}>
              {this.state.linkSent
                ? <>Verification email <em>sent</em>.</>
                : <>Please <em>verify</em> your email.</>}
            </h1>
            <p className="m-0 mb-5 text-[13px] text-mov-ink-soft">
              {this.state.linkSent
                ? 'Refresh this page once you’ve verified to continue.'
                : 'Check your inbox for a verification link before continuing.'}
            </p>
            {!this.state.linkSent && (
              <Button variant="primary" onClick={this.sendVerificationLink}>
                Send the email again
              </Button>
            )}
            <div className="mt-4 text-[12.5px] text-mov-ink-soft">
              <button
                type="button"
                onClick={this.props.store.auth.signOut}
                className="text-mov-accent-ink underline cursor-pointer"
                style={{ background: 'transparent', border: 0, padding: 0 }}
              >
                Use a different account
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default inject('store')(observer(EmailVerificationPage));
